import template from './sw-cms-block-acris-blog.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-acris-blog', {
    template
});
